import { render, staticRenderFns } from "./chathead.vue?vue&type=template&id=2beed650&scoped=true&"
import script from "./chathead.vue?vue&type=script&lang=js&"
export * from "./chathead.vue?vue&type=script&lang=js&"
import style0 from "./chathead.vue?vue&type=style&index=0&id=2beed650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beed650",
  null
  
)

export default component.exports